<template>
  <layout>
    <template v-slot:header>
      <Nav :customer="customer" />
    </template>

    <v-container>
      <v-card class="mb-5 elevation-0" >
        <v-card-title>{{$t('customer.admin.info.title')}}</v-card-title>
        <v-card-text>
          {{$t('customer.admin.info.body')}}
        </v-card-text>
      </v-card>
      
    </v-container>
  </layout>
</template>

<script>
import Layout from "@/layouts/default";

import Nav from "@/components/_layout/navigation";

import { formatMixin, formMixin, listMixin } from "@/helpers/mixins";

export default {
  name: "home",
  mixins: [formatMixin, formMixin, listMixin],
  components: {
    Layout,
    Nav
  },
  data: function() {
    return {
      qas: [],
      customer: this.$route.meta.customer,
    };
  },
  computed: {
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
